import * as angular from 'angular';

import { IUserService } from '../../services';
import { IUserModel, ComponentDefinition } from '../../models';

class UsersListController implements angular.IComponentController {
    users: IUserModel[];
    isLoading: boolean;

    static $inject = ['userService'];

    constructor(private _userService: IUserService) {
    }

    $onInit() {
        this.isLoading = true;
        this._userService
            .getUsersWithEMailAddress()
            .then(data => {
                this.users = data.map((user: any) => {
                    return {
                        userName: user.userName,
                        firstName: user.wideUserInfo.firstName,
                        lastName: user.wideUserInfo.lastName,
                        email: user.email,
                        pictureUrl: user.wideUserInfo.pictureUrl,
                        phoneNumber: user.phoneNumber,
                        password: '',
                        confirmPassword: '',
                        isSuperAdmin: false,
                        guid: user.id,
                        name: undefined,
                        roles: []
                    };
                });
            })
            .finally(() => {
                this.isLoading = false;
            });
    }
}

export const wtUsersList: ComponentDefinition = {
    componentId: 'wtUsersList',
    controller: UsersListController,
    template: require('./usersList.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
